var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","float":"left"}},[_c('hr',{style:('width:' + _vm.width + '%;height:2px;background-color:#e0e0e0;margin-left:auto;margin-right:auto;')})])}
var staticRenderFns = []

export { render, staticRenderFns }